import { render, staticRenderFns } from "./ComplaintTrendsBy.vue?vue&type=template&id=9b46efae"
import script from "./ComplaintTrendsBy.vue?vue&type=script&lang=js"
export * from "./ComplaintTrendsBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports